import SLICE from './_create.slice';

export const { initialState } = SLICE;

export default initialState;